<div class="container-fluid">
  <div class="row progress-bar-container">
    <emm-progress-bar [isLoading$]="isLoading$"></emm-progress-bar>
  </div>
</div>
<div class="banner">
  <emm-menu-banner [effectiveDate]="effectiveDate$ | async" [isFutureDate]="isFutureDate$ | async"
    [selectedConsumer]="selectedConsumer$ | async"
    [selectedFeatureScope]="selectedFeatureScope$ | async"
                     [selectedSubmenu]="(selectedSearchSubmenu$ | async) ? (selectedSearchSubmenu$ | async) :
                            (selectedSubmenu$ | async)"
    [selectedLocation]="selectedLocationSet$"
    [enablePublishButton]="canPublish | async"
    [selectedLocationType]="selectedLocationSetType$ | async"
    [selectedVenue]="selectedVenue$ | async"
    [selectedEffectiveDate]="effectiveDate$" [isSuperAdmin]="isSuperAdmin" [isAdmin]="isAdmin"
    [downloadMenuTooltip]="menuLastPublishedString | async"
    (publishButtonClicked)="handlePublishButtonClicked()"
    (downloadMenuButtonClicked)="handleDownloadMenuClicked($event)"
    (downloadItemsReportButtonClicked)="handleDownloadItemsReportClicked($event)"
    (viewChangeSets)="viewChangeSets()"
    [isSubmenuCacheEnabled]="isSubmenuCacheEnabled" (clearSubmenuCache)="clearSubmenuCache()"
    [style.width]="centerPaneWidth">
  </emm-menu-banner>
  <div class="row global-header">
    @if ((selectedFeatureScope$ | async) === 'Global' && selectedLocationSet$ | async) {
      <emm-menu-header-global
        [selectedConsumer]="selectedConsumer$ | async"
        [selectedLocation]="selectedLocationSet$ | async"
        (add)="createGlobalSubMenu()" (searchButtonClicked)="onFilter($event)"
        (clearSearchButtonClicked)="exitSearchMode()" (sortByName)="sortByName()"
        (sortByTag)="sortByTag()" (expandAll)="expandAll = $event"
        (expandChecked)="expandChecked = $event">
      </emm-menu-header-global>
    }
    @if ((selectedFeatureScope$ | async) !== 'Global') {
      <emm-menu-key-header
        [selectedFeatureScope]="selectedFeatureScope$ | async"
        [selectedConsumer]="selectedConsumer$ | async"
        [selectedLocation]="selectedLocationSet$ | async" (add)="createSubMenu()"
        [contentLoading]="isLoading$ | async" (searchButtonClicked)="onFilter($event)"
        (clearSearchButtonClicked)="exitSearchMode()"
        [selectedEffectiveDate]="effectiveDate$" [isSuperAdmin]="isSuperAdmin" [isAdmin]="isAdmin">
      </emm-menu-key-header>
    }
  </div>
</div>
<div class="w-100 menu-tree-content"
  [style.padding-bottom]="((selectedFeatureScope$ | async) !== 'Viewer') ? '50px' : '0px'">
  <div class="progress-bar-container">
    <emm-progress-bar [isLoading$]="isLoading$"></emm-progress-bar>
  </div>

  <!-- Search by tag results -->
  @if (isSearchMode$ | async) {
    <main>
      <div class="progress-bar-container search-progress">
        @if (isSearching | async) {
          <emm-progress-bar [isLoading$]="isSearching"></emm-progress-bar>
        }
      </div>
      @if (!(searchFailed | async)) {
        <div id="searchSnackbar">
          <strong>Please wait for the search to complete</strong>
          <p>It might take a few seconds depending on the number of results.</p>
          <br>
            <p>
              Please note, the results may not accurately show whether an item is disabled or not. You can click on
              the item and view the status in the right pane.
            </p>
          </div>
        }
        @if ((searchFailed | async)) {
          <div id="searchFailed">
            <strong>There were no results for that tag</strong>
            <p>Please try again.</p>
          </div>
        }
        @if (!(isSearching | async)) {
          <emm-generic-items-tree
            [items]="filteredMenuTree$ | async"
            [options]="options"
            [readonly]="isReadOnly$ | async"
            [searchedTag]="searchedTag$ | async"
            [contextMenuActions]="searchTreeContextMenuActions"
          ></emm-generic-items-tree>
        }
      </main>
    }

    <!-- Menu Viewer -->
    @if (((selectedFeatureScope$ | async) === 'Viewer') && (selectedLocationSet$ | async) &&
      (selectedConsumer$ | async) && !(isSearchMode$ | async)) {
      <main>
        @if (selectedConsumer$ | async) {
          <emm-item-detail-tree [isLoading]="isLoading$ | async" [items]="items$ | async" [options]="options"
            [readonly]="isReadOnly$ | async" [selectedFeatureScope]="selectedFeatureScope$ | async"
            [selectedConsumer]="selectedConsumer$ | async"
            [selectedLocation]="selectedLocationSet$ | async"
            class="col w-100"
          ></emm-item-detail-tree>
        }
      </main>
    }

    <!-- Global menu builder -->
    @if ((selectedFeatureScope$ | async) === 'Global' && (selectedLocationSet$ | async)  && !(isSearchMode$ | async)) {
      <main
        >
        <div [style.overflow-y]="'scroll'">
          <mat-accordion>
            @for (node of nodes$ | async; track node) {
              <mat-expansion-panel (opened)="handlePanelExpand(node)"
                (closed)="handlePanelClose(node)" class="expansion-panel">
                <mat-expansion-panel-header class="cma-expansion-panel-header">
                  <div class="cma-container">
                    <div class="cma-right">
                      <div class="cma-name">{{node.name}}
                        @if (
                            (node.id.includes('MOBILE') && node.id.includes('_R1')) ||
                            node.id.includes('_R3') ||
                            node.id.includes('_R4') ||
                            node.id.includes('_R5')
                            ) {
                          <mat-icon
                            class="new-submenu-icon"
                            matTooltip="This submenus uses some Common Items">
                            fiber_new
                          </mat-icon>
                        }
                      </div>
                      <div class="cma-id">{{node.id}}</div>
                    </div>
                  </div>
                </mat-expansion-panel-header>
                <mat-divider></mat-divider>
                <div class="submenu-content">
                  <div class="progress-bar-container">
                    <emm-progress-bar [isLoading$]="isLoadingSubmenuItems$"></emm-progress-bar>
                  </div>
                  @if ((selectedSubmenu$ | async) === node.id) {
                    <div>
                      @if ((isLoadingSubmenuItems$ | async) === false) {
                        <div>
                          <emm-item-detail-tree [expandFirstNode]="true" [isLoading]="isLoading$ | async"
                            [items]="items$ | async" [options]="options"
                            [readonly]="isReadOnly$ | async"
                            [selectedFeatureScope]="selectedFeatureScope$ | async"
                            [selectedConsumer]="selectedConsumer$ | async"
                            [copyAcrossSubmenu]="isCopied"
                            [selectedLocation]="selectedLocationSet$ | async"
                            (addItem)="addItem($event)"
                            (pasteItemCascade)="pasteItemCascade($event)"
                            (copyItem)="copyItem($event)"
                            (deleteItem)="deleteItem($event)"
                            (deleteItemCascade)="deleteItemCascade($event)"
                            (moveItem)="moveItem($event)"
                            (pasteItem)="pasteItem($event)"
                            (toggleItemDisabled)="toggleItemDisabled($event)"
                            (treeState)="setTreeState($event)">
                          </emm-item-detail-tree>
                          <div id="copiedSnackbar">
                            <span style="color: #679a7a; position: relative; top: 5px; margin-right: 3px;"><mat-icon>done</mat-icon></span>
                            <strong>Copied to clipboard</strong>
                            <button mat-icon-button class="close" (click)="closeCopiedSnackbar()">
                              <mat-icon matTooltip="Close this message">close</mat-icon>
                            </button>
                            <br>
                              <ul style="list-style-type: circle">
                                <li>Select a node in a submenu, right click and <strong>Paste Item</strong>
                                <br>
                                  or
                                </li>
                                <li>Select a node in a submenu, right click and <strong>Paste Cascade</strong>
                                to add it to multiple submenus
                              </li>
                            </ul>
                          </div>
                          <div id="moveFailed">
                            <strong>The item could not be moved.</strong>
                            <p>Please make sure the item does not exist on the target position.</p>
                            <p>Please wait for the menu to reload the item back to its original position.</p>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      </main>
    }

    <!-- Consumer menu assignment -->
    @if ((selectedFeatureScope$ | async) === 'Client' && (selectedLocationSet$ | async) && !(isSearchMode$ | async)) {
      <main
        >
        <!-- CMA Select View -->
        @if (!showCheckedSubmenusOnly) {
          <div>
            <mat-accordion>
              @for (node of selectViewNodes; track node) {
                <div>
                  <mat-expansion-panel (opened)="handlePanelExpand(node)"
                    (closed)="handlePanelClose(node)" class="expansion-panel">
                    <mat-expansion-panel-header class="expansion-panel-header">
                      @if (!showCheckedSubmenusOnly) {
                        <div class="cma-left">
                          <!-- stopPropagation to stop panel opening when clicking checkbox -->
                          <mat-checkbox (click)="$event.stopPropagation()"
                            (keydown)="$event.stopPropagation()" [checked]="node.assigned"
                            (change)="handleCheckboxSubmenu(node, $event)">
                          </mat-checkbox>
                        </div>
                      }
                      <div class="cma-container row w-100">
                        <div class="cma-right" [style]="'margin-left: 10px;'">
                          <div class="cma-name">{{node.name}}</div>
                          <div class="cma-id">{{node.id}}</div>
                        </div>
                      </div>
                    </mat-expansion-panel-header>
                    <mat-divider></mat-divider>
                    <div class="submenu-content">
                      <div class="progress-bar-container">
                        <emm-progress-bar [isLoading$]="isLoadingSubmenuItems$"></emm-progress-bar>
                      </div>
                      @if ((selectedSubmenu$ | async) === node.id) {
                        <div>
                          @if ((isLoadingSubmenuItems$ | async) === false) {
                            <div>
                              <emm-item-detail-tree [expandFirstNode]="true" [isLoading]="isLoading$ | async"
                                [items]="items$ | async" [options]="options"
                                [readonly]="isReadOnly$ | async"
                                [selectedFeatureScope]="selectedFeatureScope$ | async"
                                [selectedConsumer]="selectedConsumer$ | async"
                              [selectedLocation]="selectedLocationSet$ | async"></emm-item-detail-tree>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </mat-expansion-panel>
                </div>
              }
            </mat-accordion>
          </div>
        }
        <!-- CMA Preview and Sort View -->
        @if (showCheckedSubmenusOnly) {
          <div id="cma-sort" cdkScrollable>
            <div class="sort-instructions-always">
              <mat-icon>info</mat-icon>
              <span>Drag panels by their header to reorder. Close any open panel before dragging.</span>
            </div>
            <mat-accordion
              cdkDropList (cdkDropListDropped)="drop($event)">
              @for (node of sortedPreviewNodes; track node) {
                <div cdkDrag [cdkDragDisabled]="panelExpanded">
                  <mat-expansion-panel (opened)="handlePanelExpand(node)"
                    (closed)="handlePanelClose(node)" class="expansion-panel">
                    <mat-expansion-panel-header class="cma-expansion-panel-header" cdkDragHandle>
                      <div class="drag-handle-indicator">
                        <mat-icon>drag_indicator</mat-icon>
                      </div>
                      <div>
                        <div class="cma-name">{{node.name}}</div>
                        <div class="cma-id">{{node.id}}</div>
                      </div>
                    </mat-expansion-panel-header>
                    <mat-divider></mat-divider>
                    <div class="submenu-content">
                      <div class="progress-bar-container">
                        <emm-progress-bar [isLoading$]="isLoadingSubmenuItems$"></emm-progress-bar>
                      </div>
                      @if ((selectedSubmenu$ | async) === node.id) {
                        <div>
                          @if ((isLoadingSubmenuItems$ | async) === false) {
                            <div>
                              <emm-item-detail-tree [expandFirstNode]="true" [isLoading]="isLoading$ | async"
                                [items]="items$ | async" [options]="options"
                                [readonly]="isReadOnly$ | async"
                                [selectedFeatureScope]="selectedFeatureScope$ | async"
                                [selectedConsumer]="selectedConsumer$ | async"
                              [selectedLocation]="selectedLocationSet$ | async"></emm-item-detail-tree>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </mat-expansion-panel>
                </div>
              }
            </mat-accordion>
          </div>
        }
      </main>
    }

  </div>
  @if ((selectedFeatureScope$ | async) !== 'Viewer') {
    <div class="row row-bottom" [style.width]="centerPaneWidth">
      <emm-items-controls-footer [showSaveButton]="showSaveButton" [disabled]="isReadOnly$ | async"
        [isLoading]="isLoading$ | async" [featureScope]="selectedFeatureScope$ | async"
        [consumer]="selectedConsumer$ | async" [location]="selectedLocationSet$ | async"
        [showNextButton]="showNextButton" [contentLoading]="isLoading$ | async"
        [submenu]="selectedSubmenu$ | async"
        [isDragAndDropEnabled]="isDragAndDropEnabled$ | async"
        (handleChange)="toggleDragAndDrop($event)"
        (saveAssignments)="handleSaveAssignments()" (cancel)="resetToInitialView()"
        (nextButtonClicked)="handleNextButtonClicked()"
      ></emm-items-controls-footer>
    </div>
  }
